module.exports = __webpack_public_path__ + "static/media/icon_bot_atualizado.a6ea8c1e.svg";